const headerStyle = {};

const headerBackTitleStyle = {
  margin: 0,
  padding: 0,
  textAlign: 'left',
};

const headerTitleStyle = {
  fontFamily: 'figtree-medium',
  fontSize: 16,
  lineHeight: 20,
  letterSpacing: 0,
  margin: 0,
  padding: 0,
};

const headerLeftContainerStyle = {
  padding: 0,
  margin: 0,
};

const headerTitleContainerStyle = {
  // top: 17,
  // left: 54,
  // right: 94,
};

export {
  headerStyle,
  headerTitleStyle,
  headerLeftContainerStyle,
  headerBackTitleStyle,
  headerTitleContainerStyle,
};
